import { defineComponent as _defineComponent } from 'vue'
import BRadioGroup from 'JS/components/blain-form/BRadioGroup.vue';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import Icon from 'JS/components/Icon.vue';
import WarrantyOption from './WarrantyOption.vue';
import { AddToCartProduct } from 'JS/services/ProductService';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WarrantySidebar',
  props: {
    product: null,
    showErrorMessage: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["update", "decline"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update', product: AddToCartProduct, warrantySku: string): void,
	(e: 'decline'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	product: AddToCartProduct,
	showErrorMessage: boolean,
	loading: boolean,
}





const selectedWarranty = ref<string>('');
const errorMessage = "<span class='bold'>Failed to add warranty.</span> Please try again.";
const applyWarrantyCTA = computed<string>(() => props.showErrorMessage ? 'Try Again' : 'Protect Your Purchase');

onMounted(() => {
	window.blainGtmDataLayer.push({
		'event': "warranty_impression"
	});
});

function isSelectedWarranty(warrantySku: string): boolean {
	return warrantySku == selectedWarranty.value;
}

function applySelectedWarranty() {
	emit('update', props.product, selectedWarranty.value);
}


return { __sfc: true,props, emit, selectedWarranty, errorMessage, applyWarrantyCTA, isSelectedWarranty, applySelectedWarranty, BRadioGroup, ErrorBanner, Icon, WarrantyOption }
}

})